import { render, staticRenderFns } from "./LeaveCountsComponent.vue?vue&type=template&id=28493d69&"
import script from "./LeaveCountsComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaveCountsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports